import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { marginAttributes, widthAttributes } from '../../system/attributes';
import { makePropList, getPropsBlocker } from '../../utils';
var propertyList = makePropList(['enableBottomSeparator']);

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var theme = _ref.theme;
  var Navigation = theme.componentOverrides.Navigation;
  var result = Navigation.Root.base;
  return result;
};

export var NavigationRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n\n    ", "\n    ", "\n    ", "\n"])), getRootDynamicStyle, marginAttributes, widthAttributes);